import { MenuItemProps, useTranslationRoute, useTranslations } from "@harea/component"
import { useMemo } from "react"

export const useWizardDetailsMenu = (id: number) => {
    
    const [
        ABOUT,
        DESIGNER,
        PARAMS
    ] = useTranslations(i18n)
    
    const translatedRoute = useTranslationRoute()

    return useMemo((): Array<MenuItemProps> => ([
        {
            ke: 'about',
            label: ABOUT,
            link: translatedRoute(`admin/wizard/${id}/about`),
            
        },
        {
            ke: 'designer',
            label: DESIGNER,
            link: translatedRoute(`admin/wizard/${id}/designer`),
        },
        {
            ke: 'params',
            label: PARAMS,
            link: translatedRoute(`admin/wizard/${id}/params`),
        },
    ]), [ABOUT])
}

const i18n = [
    'std_about',
    'std_designer',
    'std_params'
]
